<template>
  <div>
    <b-container class="footer">
      <div>
        <a href="https://www.fernbrookhomes.com/" target="_blank">
          <b-img class="logo ml-0 ml-sm-0 ml-md-5" src="/img/fernbrook-w.png" fluid /></a>
        <a href="http://tiffanyparkhomes.com/" target="_blank">
          <b-img class="logo" src="/img/tiffany-w.png" fluid /></a>
      </div>
      <div style="font-size:12px; color:#fff;">© 2026 MAPLEVIEW PARK. All rights reserved.</div>
      <div style="padding-bottom:2rem;">
      <a href="/privacy-policy"  style="font-size:12px; color:#fff;">Privacy Policy</a>
      </div>
    </b-container>
  </div>
</template>

<style lang="scss">
.footer{
  div{
    background-color: #29AAE1;
    @media screen and (max-width: 768px){
      text-align: center;
    }
  }
  .logo{
    width: 175px;
    margin:  25px 10px 25px 0px;
    @media screen and (max-width: 768px){
      width: 125px;
      margin: 15px auto !important;
    }
  }
}

</style>
